import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Welcome.css';
import Header from '/Users/noshadboksh/FINALYEAR/react-schedule/src/components/auth/Header.jsx'; // Make sure this path is correct

const Welcome = () => {
    const navigate = useNavigate();


    useEffect(() => {
        const particleContainer = document.querySelector('.boxes');
        const maxParticles = 20;
        let particlesCount = 0;

        const createParticle = () => {
            if (particlesCount >= maxParticles) return;

            const particle = document.createElement('div');
            particle.className = 'particle';
            particle.style.left = `${Math.random() * 100}%`;
            particle.style.top = `${Math.random() * 100}%`;
            particle.style.animationDuration = `${Math.random() * 3 + 2}s`;
            particle.style.backgroundColor = `hsla(${Math.random() * 360}, 70%, 80%, 0.7)`;
            particleContainer.appendChild(particle);
            particlesCount++;

            particle.addEventListener('animationend', () => {
                particle.remove();
                particlesCount--;
            });
        };

        const intervalId = setInterval(createParticle, 1000);

        // Clean up the interval and particles when the component unmounts
        return () => {
            clearInterval(intervalId);
            while (particleContainer.firstChild) {
                particleContainer.removeChild(particleContainer.firstChild);
            }
        };
    }, []);



    return (
        <div className="wrapper">
            <Header /> {/* This includes the night mode toggle in the header */}
            <h2>Welcome to ScheduleSmart</h2>
            <div className="buttons">
                <button onClick={() => navigate('/signin')}>Log In</button>
                <button onClick={() => navigate('/signup')}>Sign Up</button>
            </div>
            <div className="boxes"></div>
        </div>
    );
};



export default Welcome;
